import React from "react";

const CloseIcon = (props) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="19"
			height="18"
			viewBox="0 0 19 18"
			fill="none"
			{...props}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.71967 3.21967C3.42678 3.51256 3.42678 3.98744 3.71967 4.28033L8.36974 8.9304L3.71974 13.5804C3.42685 13.8733 3.42685 14.3482 3.71974 14.6411C4.01263 14.9339 4.48751 14.9339 4.7804 14.6411L9.4304 9.99106L14.08 14.6407C14.3729 14.9336 14.8478 14.9336 15.1407 14.6407C15.4336 14.3478 15.4336 13.8729 15.1407 13.58L10.4911 8.9304L15.1408 4.2807C15.4337 3.9878 15.4337 3.51293 15.1408 3.22004C14.8479 2.92714 14.373 2.92714 14.0801 3.22004L9.4304 7.86974L4.78033 3.21967C4.48744 2.92678 4.01256 2.92678 3.71967 3.21967Z"
				fill={props.fill || "#6E7191"}
			/>
		</svg>
	);
};

export default CloseIcon;
